'use client';

import { c as _c } from "react/compiler-runtime";
import { cva, type VariantProps } from 'class-variance-authority';
import { CheckIcon } from 'lucide-react';
import { Checkbox as CheckboxPrimitive } from 'radix-ui';
import * as React from 'react';
import { cn } from '@/lib/utils';
const checkboxVariants = cva('peer shrink-0 rounded ring-offset-background focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-primary focus-visible:ring-offset-1 disabled:cursor-not-allowed disabled:opacity-50', {
  variants: {
    variant: {
      default: 'border-input dark:bg-input/10 dark:hover:bg-input/20 group-hover:bg-input/30 data-[state=checked]:dark:bg-primary data-[state=checked]:dark:hover:bg-primary data-[state=checked]:text-primary-foreground',
      secondary: 'border-input dark:bg-input/10 dark:hover:bg-input/20 group-hover:bg-input/30 data-[state=checked]:dark:bg-secondary data-[state=checked]:dark:hover:bg-secondary data-[state=checked]:text-secondary-foreground'
    },
    size: {
      default: 'h-6 w-6',
      sm: 'h-5 w-5',
      xs: 'h-4 w-4'
    }
  },
  defaultVariants: {
    variant: 'default',
    size: 'default'
  }
});
export type CheckboxProps = React.ComponentProps<typeof CheckboxPrimitive.Root> & VariantProps<typeof checkboxVariants>;
export const Checkbox = t0 => {
  const $ = _c(15);
  let className;
  let props;
  let size;
  let variant;
  if ($[0] !== t0) {
    ({
      className,
      variant,
      size,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
    $[3] = size;
    $[4] = variant;
  } else {
    className = $[1];
    props = $[2];
    size = $[3];
    variant = $[4];
  }
  const resolvedSize = size ?? "default";
  let t1;
  if ($[5] !== className || $[6] !== size || $[7] !== variant) {
    t1 = cn(checkboxVariants({
      variant,
      size
    }), className);
    $[5] = className;
    $[6] = size;
    $[7] = variant;
    $[8] = t1;
  } else {
    t1 = $[8];
  }
  const t2 = resolvedSize === "sm" ? "h-3.5 w-3.5" : resolvedSize === "xs" ? "h-3 w-3" : "h-4 w-4";
  let t3;
  if ($[9] !== t2) {
    t3 = <CheckboxPrimitive.Indicator data-slot="checkbox-indicator" className="grid place-content-center text-current transition-none"><CheckIcon className={t2} /></CheckboxPrimitive.Indicator>;
    $[9] = t2;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== props || $[12] !== t1 || $[13] !== t3) {
    t4 = <CheckboxPrimitive.Root data-slot="checkbox" className={t1} {...props}>{t3}</CheckboxPrimitive.Root>;
    $[11] = props;
    $[12] = t1;
    $[13] = t3;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  return t4;
};
Checkbox.displayName = 'Checkbox';